import ViewPlanning from '../components/viewPlanning';
import { helpCollaboration } from './variables/helpContent';

export default function Collaboration() {
	return (
		<ViewPlanning
			planningType='collaboration'
			helpContent={helpCollaboration}
		/>
	);
}
